import { create as I } from "zustand";
import { temporal as O } from "zundo";
import { immer as V } from "zustand/middleware/immer";
import { mountStoreDevtool as E } from "./index39.js";
import N from "just-throttle";
import { subscribeWithSelector as D } from "zustand/middleware";
import { initialState as l } from "./index40.js";
import { initialState as w } from "./index41.js";
import { initialState as S } from "./index42.js";
import { getPercentageOfValue as g, getPixelValueFromPercent as m } from "./index38.js";
import { CROP_MINIMUM_DIMENSION_PERCENTAGE as C } from "./index37.js";
import { getMinimumCropAspect as x, getRatioBasedOnAspect as P, adjustDimensionsForAspectRatio as R } from "./index12.js";
import { Aspect as M } from "./index5.js";
const s = I()(
  O(
    V(
      D((t, i) => ({
        ...w,
        ...S,
        ...l,
        actions: {
          setImage: (e) => t((o) => {
            o.image = e;
          }),
          setCrop: (e) => t((o) => {
            o.crop = e;
          }),
          setCropDimension: (e, o, n) => t((r) => {
            const d = n === "px" ? g(e, r.image[o]) : e;
            r.crop[o] = d;
            const { aspect: a } = i().aspect;
            if (a === M.CUSTOM)
              return;
            const h = P(a), p = o === "width" ? "height" : "width", c = p === "width" ? e * h : e / h, u = n === "px" ? g(
              c,
              r.image[p]
            ) : c;
            r.crop[p] = u;
          }),
          resetStore: () => t((e) => {
            e.crop = w.crop, e.image = l.image, e.aspect = S.aspect;
          }),
          // aspect related actions
          setAspect: ({ aspect: e, isLocked: o }, n) => t((r) => {
            if (r.aspect = { aspect: e, isLocked: o }, !n)
              return;
            const { width: d, height: a } = x(i().image, e), { width: h, height: p } = i().crop, c = i().image, u = P(e), f = R(
              m(h, c.width),
              m(p, c.height),
              u
            );
            r.crop.width = g(
              Math.max(f.width, d),
              c.width
            ), r.crop.height = g(
              Math.max(f.height, a),
              c.height
            );
          })
        }
      }))
    ),
    {
      // set the cool-off period
      handleSet: (t) => N((i) => {
        t(i);
      }, 1e3)
      // equality: isDeepEqual,
    }
  )
);
s.subscribe(
  (t) => [t.aspect, t.crop],
  ([t]) => {
  }
);
const _ = () => s((t) => t.crop), b = () => s((t) => t.aspect), A = () => s((t) => t.image), z = () => s((t) => t.actions), J = () => {
  const t = A(), i = _();
  return {
    x: m(i.x, t.width),
    y: m(i.y, t.height),
    width: m(i.width, t.width),
    height: m(i.height, t.height),
    unit: "px"
  };
}, K = () => {
  const t = A(), { aspect: i } = b(), e = m(
    C,
    t.width
  ), o = m(
    C,
    t.height
  );
  return i === M.CUSTOM ? {
    width: e,
    height: o
  } : x(t, i);
};
process.env.NODE_ENV === "development" && E("ImageCropStore", s);
export {
  b as useAspectProperties,
  J as useCropPixelProperties,
  _ as useCropProperties,
  z as useImageCropperActions,
  s as useImageCropperStore,
  A as useImageProperties,
  K as useMinimumCropValues
};
